export enum CHECKLIST_OPTIONS {
  SECTION_AUTO_EXPAND_CHILDREN_LENGTH = 5,
  SECTION_MAX_DEPTH = 4,
}

export enum TAB_INDEX {
  UNSET = -1,
  SAVED_CHECKLIST = 0,
  LEXIS_NEXIS_CHECKLIST = 1,
}

export enum COLUMN_TITLE_MIN_WIDTH {
  COMPACT = '260px',
  FULL = '500px',
}